var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"mt-4 caption footer",attrs:{"app":"","absolute":"","fixed":"","elevation":"5"}},[_c('v-spacer'),_c('span',[_vm._v("@"+_vm._s(_vm.app_name)+" "+_vm._s(_vm.$store.getters.appVersion))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }